/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import React from "react";
// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";

import Footer from "../../examples/Footer";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import useSWR from "swr";
import { allImages } from "../../utils/contants";
import { FaCircleStop } from "react-icons/fa6";
import { FaCirclePlay } from "react-icons/fa6";
import OrderDetails from "../../components/OrderDetails";
import Rating from "@mui/material/Rating";
import arrowimg from "../../assets/images/arrowimg.png";
import ModalComponent from "components/ModalComponent";
import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";
import { Link } from "react-router-dom";
// Dashboard components

import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import LoaderComponent from "components/Loader";
import { baseURL } from "utils/api";
import axios from "axios";
import TabComponent from "components/TabComponent";
import Select from "react-select";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
function OrderList() {
  const navigate = useNavigate();
  // fetch data swr
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState([]);
  const [file, setFile] = useState("");
  // useEffect(() => {
  //   async function fetchData() {
  //     setLoading(true);
  //     const { data } = await axios.get(`${baseURL}/admin/fetch-categories`);
  //     setLoading(false);

  //     setData(data?.categories);
  //     //  console.log(data);
  //   }
  //   fetchData();
  // }, []);

  // get random image to display in order table-:

  const randomIndex = Math.floor(Math.random() * allImages.length);

  // Get the random image URL
  const randomImageUrl = allImages[randomIndex];

  const fetchData = async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
  const { data, error } = useSWR(`${baseURL}/order/admin/fetch-orders`, fetchData, {
    refreshInterval: 1000,
  });
  console.log(data, "data");

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const closeModal = () => {
    setOpenModal(false);
  };

  const columns = [
    {
      field: "pName",
      headerName: "Product Name",
      width: "180",
    },

    {
      field: "img",
      headerName: "Image",
      width: 100,
      renderCell: (param) => {
        return (
          <img
            src={param.row?.img}
            alt="image_order"
            style={{
              height: "15vh",
              width: "auto",
              objectFit: "contain",
            }}
          />
        );
      },
    },

    {
      field: "ordDetails",
      headerName: "Order Details",
      width: 200,
    },
    {
      field: "skuId",
      headerName: "SkuId-store",
      width: 100,
    },
    {
      field: "userName",
      headerName: "User Id",
      width: 100,
    },
    {
      field: "price",
      headerName: "¥",
      width: 100,
    },
    {
      field: "unitPrice",
      headerName: "Unit Price",
      width: 150,
      // editable: true,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 100,
      // editable: true,
    },
    {
      field: "totalPrice",
      headerName: "Total Price",
      width: 100,
      // editable: true,
    },
    {
      field: "mode",
      headerName: "Mode",
      width: 100,
      // editable: true,
    },
    {
      field: "orderDate",
      headerName: "Order Date",
      width: 200,
      // editable: true,
    },

    {
      field: "returngoodslocation",
      headerName: "Return Goods Location",
      width: 200,
      // editable: true,
    },

    {
      field: "exchangeitemstatus",
      headerName: "Exchange Item status",
      width: 200,
      // editable: true,
    },

    {
      field: "feedback",
      headerName: "Feedback",
      width: 200,
      // editable: true,
      renderCell: (param) => {
        return (
          <>
            <div className="flex flex-col gap-2">
              <Rating name="read-only" value={5} readOnly />
              <span>Great Product</span>
            </div>
          </>
        );
      },
    },

    {
      field: "action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 180,
      renderCell: (param) => {
        const detailsObj = { ...param.row };

        const handlePreviewClick = () => {
          navigate("/ViewDetails", { state: detailsObj });
        };

        const [stoppedOrder, setStoppedOrder] = useState(null);
        const handleStopOrder = (row) => {
          setStoppedOrder(row);
        };
        // continue order handler-:
        const handleContinueOrder = () => {
          setStoppedOrder(null);
        };

        const handleStopClick = (e) => {
          handleStopOrder(param.row);
          e.stopPropagation();
        };

        const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
          [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 22,
          },
          [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
              backgroundImage:
                "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
            },
          },
          [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
              backgroundImage:
                "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
            },
          },
          [`& .${stepConnectorClasses.line}`]: {
            height: 3,
            border: 0,
            backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
            borderRadius: 1,
          },
        }));
    
        const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
          backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
          zIndex: 1,
          color: "#fff",
          width: 50,
          height: 50,
          display: "flex",
          borderRadius: "50%",
          justifyContent: "center",
          alignItems: "center",
          ...(ownerState.active && {
            backgroundImage: "linear-gradient(136deg, rgb(0, 100, 0) 0%, rgb(0, 100, 0) 100%)",
            boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
          }),
          ...(ownerState.completed && {
            backgroundImage: "linear-gradient(136deg, rgb(0, 100, 0) 0%, rgb(0, 100, 0) 100%)",
          }),
        }));
    
        function ColorlibStepIcon(props) {
          const { active, completed, className } = props;
    
          const icons = {
            1: <AssignmentReturnIcon />,
            2: <KeyboardReturnIcon />,
            3: <CurrencyExchangeIcon />,
           };
    
          return (
            <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
              {icons[String(props.icon)]}
            </ColorlibStepIconRoot>
          );
        }
    
        const steps = ["Return", "Refund", "Exchange"];

        return (
          <div style={{ display: "flex", gap: "6px" }}>
            <Tooltip title="View">
              <IconButton onClick={handlePreviewClick}>
                <MdOutlinePreview style={{ cursor: "pointer" }} />
              </IconButton>
            </Tooltip>

            {stoppedOrder?.id === param.row.id ? (
              <Tooltip title="Continue">
                <IconButton>
                  <FaCirclePlay
                    onClick={(e) => {
                      handleContinueOrder();
                      e.stopPropagation();
                    }}
                    className="text-green-400 text-xl"
                  />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Stop">
                <IconButton>
                  <FaCircleStop
                    onClick={(e) => {
                      handleStopOrder(param.row);
                      e.stopPropagation();
                    }}
                    className="text-red-400 text-xl"
                  />
                </IconButton>
              </Tooltip>
            )}

<Tooltip title="Track">
            <IconButton>
              <IoLocationOutline
                onClick={(e) => {
                  handleOpenModal();
                  e.stopPropagation();
                }}
                className="text-blue-400 cursor-pointer text-xl"
              />
            </IconButton>
          </Tooltip>
          {/* </div> */}

          <ModalComponent title={"Track Unpaid Orders"} open={openModal} handleClose={closeModal}>
            <Stack sx={{ width: "1000px" }} spacing={4}>
              <Stepper alternativeLabel activeStep={2} connector={<ColorlibConnector />}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Stack>
          </ModalComponent>
          {/* <ModalComponent
            title={" Order Details"}
            open={showOrderDetails}
            handleClose={handleHideOrderDetails}
          >
            <OrderDetails order={param.row} />
          </ModalComponent> */}




          </div>
        );
      },
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];
  const [updatedNewRow, setUpdatedRow] = useState(null);
  const initialRows = data?.unpaidWithId;
  // const initialRows = data?.categories.map((mydata) => ({
  //     ...mydata,
  //     image: { arrowimg },
  // }));
  // console.log(initialRows);

  const [rows, setRows] = useState(initialRows);
  const [rowModesModel, setRowModesModel] = useState({});
  const processRowUpdate = async (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setUpdatedRow(updatedRow);
    console.log(newRow);
    await handleUpdateCategory(newRow.id, newRow);
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));

    return updatedNewRow;
  };

  const [allIds, setAllIds] = useState([]);

  const RenderButtonCellProcessing = (param) => {
    const [stoppedOrder, setStoppedOrder] = useState(null);
    const handleStopOrder = (row) => {
      setStoppedOrder(row);
    };
    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => {
      setOpenModal(true);
    };
    const closeModal = () => {
      setOpenModal(false);
    };

    // continue order handler-:
    const handleContinueOrder = () => {
      setStoppedOrder(null);
    };

    return (
      <>
        <div className="flex items-center gap-2">
          <Tooltip title="Show Details">
            <IconButton>
              <MdOutlinePreview
                onClick={(e) => {
                  handleOpenModal();
                  e.stopPropagation();
                }}
                style={{ cursor: "pointer" }}
              />
            </IconButton>
          </Tooltip>
          {stoppedOrder?.id === param.row.id ? (
            <Tooltip title="Continue">
              <IconButton>
                <FaCirclePlay
                  onClick={(e) => {
                    handleContinueOrder();
                    e.stopPropagation();
                  }}
                  className="text-green-400 text-xl"
                />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Stop">
              <IconButton>
                <FaCircleStop
                  onClick={(e) => {
                    handleStopOrder(param.row);
                    e.stopPropagation();
                  }}
                  className="text-red-400 text-xl"
                />
              </IconButton>
            </Tooltip>
          )}
        </div>
        {/* display model on clicking on track */}
        <ModalComponent title={" Order Details"} open={openModal} handleClose={closeModal}>
          <OrderDetails order={param.row} />
        </ModalComponent>
      </>
    );
  };

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };
  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const [enableSelection, setEnableSelection] = useState(false);

  const handleEnableSelection = () => {
    setEnableSelection(!enableSelection);
  };

  const onRowsSelectionHandler = (ids) => {
    const selectedRowsData = ids.map((id) => initialRows.find((row) => row.id === id));
    const foundIds = selectedRowsData.map((d) => d.id);
    setAllIds(foundIds);
  };

  //

  const [tableType, setTableType] = useState("Unpaid");

  //

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!data && <LoaderComponent open={true} />}
      {/* {formLoading && <LoaderComponent open={true} />} */}

      {/*             
                {
                    allIds.length > 0 && <button onClick={handleDeleteSelectedRows} type="button" className="bg-green-700 h-[5vh] rounded-md w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white">Delete Selected</button>
                } */}

      <div className="flex  gap-4" style={{ marginLeft: "66%" }}>
        <Link to="/ordertracking">
          <button
            style={{ background: tableType === "Unpaid" ? "red" : "red" }}
            className={`border-none cursor-pointer  font-semibold text-white bg-slate-400  outline-none rounded-md p-3`}
          >
            Return Tracking
          </button>
        </Link>
        <Link to="/refundtracking">
          <button
            style={{ background: tableType === "Unpaid" ? "green" : "green" }}
            className={`border-none cursor-pointer  font-semibold text-white bg-slate-400  outline-none rounded-md p-3`}
          >
            Refund Tracking
          </button>
        </Link>
        <Link to="/exchangetracking">
          <button
            style={{ background: tableType === "Processing" ? "blue" : "blue" }}
            className={`border-none  cursor-pointer font-semibold text-white bg-slate-400  outline-none rounded-md p-3`}
          >
            Exchange Tracking
          </button>
        </Link>
      </div>
      <Box sx={{ height: 550, width: "100%", background: "white", marginTop: "1%" }}>
        {tableType === "Unpaid" ? (
          <DataGrid
            rows={initialRows ? initialRows : []}
            columns={columns}
            editMode="row"
            checkboxSelection={true}
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
            experimentalFeatures={{ newEditingApi: true }}
            // slots={{
            //   toolbar: EditToolbar,
            // }}
            slotProps={{
              toolbar: { setRows, setRowModesModel },
            }}
          />
        ) : tableType === "Processing" ? (
          <ProcessingTable />
        ) : tableType === "Shipped" ? (
          <ShippingTable />
        ) : (
          <ReviewTable />
        )}
      </Box>

      <Footer />
    </DashboardLayout>
  );
}

export default OrderList;
